import styled from "styled-components";
import { FilterGroupItems } from "components/FilterGroup/styles";

export const ExamScreenDesktopFilterContainer = styled.div`
    ${FilterGroupItems} {
        margin: 0;
        padding-top: 0;
    }
`;
